//申請不備理由登録画面のラベル
export const LABELS = {
  COMPANY_NAME: "事業者名",
  CORP_NUMBER: "法人番号",
  COMPANY_ADDRESS: "事業者住所",
  MERCHANT_NAME: "加盟店名",
  INCOMPLETION_REASON: "不備理由",
  BLANK: "　",
};
// 不備理由最大文字数
export const INPUT_MAX_LENGTH = 2000;
// 処理種別 1: 画面入力
export const PROCESS_TYPE_INPUT = 1;
